import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import * as actions from '../../actions';
import { IStore } from '../../interfaces';
import { ISelectedEvolutions, ITeamTimeHonours } from '../../interfaces/clientInterfaces';
import { useAppDispatch } from '../../utils/modules';
import { CompetitionEvolution } from './CompetitionEvolution';
import styles from './CompetitionsEvolutionContainer.module.css';

interface ICompetitionsTimeSliderInjectedProps {
	viewPortX: number;
	viewPortY: number;
	selectedEvolution: ISelectedEvolutions | null;
	isMobileViewActive: boolean;
}

export default function CompetitionEvolutionContainer() {

	const dispatch = useAppDispatch();
	const {
		viewPortX, viewPortY, selectedEvolution, isMobileViewActive
	} = useSelector(
		(completeState: IStore): ICompetitionsTimeSliderInjectedProps => {
			if (completeState.competitions.selectedEvolutions.length > 0) {
				const selectedEvolution = completeState.competitions.selectedEvolutions[0];
				return {
					viewPortX: completeState.ui.viewPort.width,
					viewPortY: completeState.ui.viewPort.height,
					selectedEvolution: selectedEvolution,
					isMobileViewActive: completeState.ui.isMobileViewActive,
				};
			}
			return {
				viewPortX: 0,
				viewPortY: 0,
				selectedEvolution: null,
				isMobileViewActive: completeState.ui.isMobileViewActive,
			};
		});


	const onChangeRange = useCallback((startIndex: number, endIndex: number) => {
		dispatch(actions.onChangeRangeOfEvolution(0, startIndex, endIndex));
	}, [dispatch]);

	const returnTitlesOfTeam = (teamTimeHonours: ITeamTimeHonours, selectedEvolution: ISelectedEvolutions) => {
		let width = 100;
		let isRunnerUp = false;
		let numberChampionsText = '';
		if (teamTimeHonours.timesChampion > 0) {
			width = 100 * teamTimeHonours.timesChampion / selectedEvolution.maxTitlesInCurrentStatus;
			numberChampionsText = teamTimeHonours.timesChampion.toString();
		} else {
			width = 100 * teamTimeHonours.timesRunnerUp / selectedEvolution.maxTitlesInCurrentStatus;
			isRunnerUp = true;
			numberChampionsText = isMobileViewActive ? '0' : `${teamTimeHonours.timesRunnerUp} Runner up`;
		}
		return (
			<div className={styles.teamTimeHonourContainer}
				onClick={e => dispatch(actions.setHomeDetailTeam(teamTimeHonours.teamId))}
			>
				<div
					className={isMobileViewActive ? styles.mobileTeamTimeHonourNameAndImage : styles.teamTimeHonourNameAndImage}
				>
					<img
						className={styles.teamScarfImage}
						src={`./../../img/scarf/${teamTimeHonours.scarfCode}.jpg`}
						style={{
							maxWidth: isMobileViewActive ? '120px' : '160px'
						}}
						alt={teamTimeHonours.teamName}
					/>
				</div>
				<div
					className={styles.titlesBarContainer}
					style={{
						opacity: isRunnerUp ? 0.7 : 1
					}}
				>
					<div className={styles.contentOfBar}>
						{teamTimeHonours.regionCode
							? <img
								className={styles.regionImage}
								alt={teamTimeHonours.regionCode}
								src={`./../../img/flag/${teamTimeHonours.regionCode}.png`}
							/>
							: null}
						<img
							className={isMobileViewActive ? styles.mobileTeamShieldImage : styles.teamShieldImage}
							style={{ margin: `auto ${!!teamTimeHonours.regionCode ? '0' : '3px'}`}}
							src={`./../../img/shield/${teamTimeHonours.shieldCode}.png`}
							title={teamTimeHonours.teamName}
							alt={teamTimeHonours.teamName}
						/>
						<div
							className={styles.teamNameContainer}
							style={{
								fontSize: isMobileViewActive ? '10px' : '12px'
							}}
						>
							{teamTimeHonours.teamName}
						</div>
						<div className={styles.titlesNumberContainer}>
							{numberChampionsText}
						</div>
					</div>
					<div
						className={styles.championsBarContainer}
						style={{
							width: `${width}%`
						}}
					/>
				</div>
			</div>
		);
	};
	if (!selectedEvolution) {
		return null;
	}
	return (
		<>
			<div
				className={styles.trophyAndShieldsContainer}
				style={{
					margin: isMobileViewActive ? '5px' : '5px auto'
				}}
			>
				{selectedEvolution.lastChampionCode && <div
					className={styles.resultTeamNameContainer}
					style={{
						fontSize: isMobileViewActive ? '12px' : '15px'
					}}
				>
					{`${selectedEvolution.lastChampionTooltip}`}
				</div>}
				<div
					className={styles.teamContainer}
					onClick={e => dispatch(actions.setHomeDetailTeam(selectedEvolution.lastChampionId))}
				>
					<img
						className={styles.lastChampionShieldContainer}
						style={{ height: isMobileViewActive ? '30px' : '45px' }}
						src={`./../../img/shield/${selectedEvolution.lastChampionCode || 'ZZ_UNK'}.png`}
						title={selectedEvolution.lastChampionTooltip}
						alt={selectedEvolution.lastChampionTooltip}
					/>
					{selectedEvolution.lastChampionRegionCode
						? <img
							className={styles.championRegionShieldImage}
							style={{
								height: isMobileViewActive ? '14px' : '20px'
							}}
							src={`./../../img/flag/${selectedEvolution.lastChampionRegionCode}.png`}
							alt={selectedEvolution.lastChampionRegionCode}
						/>
						: null}
				</div>
				<img
					style={{
						height: isMobileViewActive ? '70px' : '90px'
					}}
					src={`./../../img/trophy/${selectedEvolution.competitionTrophy}.png`}
					alt={selectedEvolution.competitionName}
					title={selectedEvolution.competitionName}
				/>
				<div
					className={styles.teamContainer}
					onClick={e => dispatch(actions.setHomeDetailTeam(selectedEvolution.lastRunnerUpId))}
				>
					<img
						className={styles.lastRunnerUpShieldContainer}
						style={{
							height: isMobileViewActive ? '30px' : '45px'
						}}
						src={`./../../img/shield/${selectedEvolution.lastRunnerUpCode || 'ZZ_UNK'}.png`}
						title={selectedEvolution.lastRunnerUpTooltip}
						alt={selectedEvolution.lastRunnerUpTooltip}
					/>
					{selectedEvolution.lastRunnerUpRegionCode
						? <img
							className={styles.runnerUpRegionShieldImage}
							style={{
								height: isMobileViewActive ? '14px' : '20px'
							}}
							src={`./../../img/flag/${selectedEvolution.lastRunnerUpRegionCode}.png`}
							alt={selectedEvolution.lastRunnerUpRegionCode}
						/>
						: null}
				</div>
				{selectedEvolution.lastRunnerUpCode && <div
					className={styles.resultTeamNameContainer}
					style={{
						fontSize: isMobileViewActive ? '12px' : '15px'
					}}
				>
					{`${selectedEvolution.lastRunnerUpTooltip}`}
				</div>}
			</div>
			<div className={styles.evolutionStatusContainer}>
				{selectedEvolution.selectedTimeStatus.map(sTT => returnTitlesOfTeam(sTT, selectedEvolution))}
			</div>
			<CompetitionEvolution
				viewPortX={viewPortX}
				viewPortY={viewPortY}
				startYear={selectedEvolution.evolution.startYear}
				endYear={selectedEvolution.evolution.endYear}
				currentStartYear={selectedEvolution.selectedStartYear}
				currentStartYearText={selectedEvolution.selectedStartYearText}
				currentEndYearText={selectedEvolution.selectedEndYearText}
				currentEndYear={selectedEvolution.selectedEndYear}
				initEndIndex={selectedEvolution.selectedEndIndex}
				initStartIndex={selectedEvolution.selectedStartIndex}
				totalGaps={selectedEvolution.evolution.editions.length}
				onChangeRange={onChangeRange} />
		</>
	);
}
